import { render, staticRenderFns } from "./agricultural.vue?vue&type=template&id=d0d3e74a&scoped=true&"
import script from "./agricultural.vue?vue&type=script&lang=js&"
export * from "./agricultural.vue?vue&type=script&lang=js&"
import style0 from "./agricultural.vue?vue&type=style&index=0&id=d0d3e74a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d3e74a",
  null
  
)

export default component.exports